export const AppRoutes = {
    callback: '/callback',
    loggedOut: '/logged-out',
    home: '/home',
    claims: '/claims',
    claimDetails: (payerId = ':payerId', transactionId = ':transactionId') =>
        `/claims/${payerId}/${transactionId}`,
    termsOfUse: '/terms-of-use',
    privacyPolicy: '/privacy-policy',
    updatesHistory: '/updates-history',
} as const;
